import React from 'react';

import Stack from '@mui/material/Stack';

import { ScoreDetails } from 'ff/debrief/models';

import ApproachToolbar from './ApproachToolbar';
import ScoreBreakDown from './ScoreBreakDown';

interface Props {
    segmentLabel: string;
    segmentScore: number;
    scoringDetails: ScoreDetails[];
}

const ScoringDetails = React.forwardRef<HTMLDivElement, Props>(
    function ScoringDetails(props, ref) {
        if (props.scoringDetails) {
            return (
                <Stack
                    ref={ref}
                    sx={{
                        pl: 1.5,
                        p: 1,
                        bgcolor: '#F6F8F9',
                        mx: -2,
                        ml: '-17px',
                        borderBottomRightRadius: '8px',
                        height: '100%',
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        gap={2}
                        mb={1}
                        px={1}
                    >
                        <ApproachToolbar />
                    </Stack>
                    <ScoreBreakDown
                        scoreDetails={props.scoringDetails}
                        sx={{ flexGrow: 1 }}
                    />
                </Stack>
            );
        } else {
            return null;
        }
    }
);

export default ScoringDetails;
